import React from 'react';

import TopBar from '../../components/TopBar';
import Refresh from '../../containers/Refresh';
import WorkordersTopBarFilter from './WorkordersTopBarFilter';

const {
  ActionsLeft,
  ActionsRight,
} = TopBar;

const WorkordersTopBar = function WorkordersTopBar() {
  return (
    <TopBar>
      <ActionsLeft>
        <WorkordersTopBarFilter />
      </ActionsLeft>
      <ActionsRight>
        <Refresh />
      </ActionsRight>
    </TopBar>
  );
};

export default WorkordersTopBar;



// WEBPACK FOOTER //
// ./src/views/workorders/WorkordersTopBar.js